import SpendingAverages from "./SpendingAverages";

const SpendingAveragesPage = () => (
	<div className="lavella page spending-averages-page">
		<section>
			<div className="cont--lg" style={{ position: "relative", padding: "20px" }}>
				<SpendingAverages />
			</div>
		</section>
	</div>
);

export default SpendingAveragesPage;
